import { fbDateToUnix } from "./Globals"
import Project, { ProjectForcedStates } from "./Project"


export enum ProjectStatusLabel {
    PROJECT_COMMING_SOON = "PROJECT_COMMING_SOON",
    PROJECT_OPEN_FOR_INVESTMENT = "PROJECT_OPEN_FOR_INVESTMENT",
    PROJECT_WAITING_FOR_START = "PROJECT_WAITING_FOR_START",
    PROJECT_IN_PROGRESS = "PROJECT_IN_PROGRESS",
    PROJECT_IN_COMPLETED = "PROJECT_IN_COMPLETED",
    PROJECT_FAILED = "PROJECT_FAILED",
    PROJECT_FAIL_IN_PROCESS = "PROJECT_FAIL_IN_PROCESS",
}

export enum ProjectStatusColor {
    YELLOW = 'YELLOW',
    GREEN = 'GREEN',
    GRAY = 'GRAY',
    BLUE = 'BLUE',
    RED = 'RED',

}

export type ProjectStatusUILabel = {
    name: ProjectStatusLabel | string,
    color: ProjectStatusColor
}

export enum ProjectStatus {
    HIDDEN = "HIDDEN",
    COMMING_SOON = "COMMING_SOON",
    OPEN_FOR_INVESTMENT = "OPEN_FOR_INVESTMENT",
    WAITING_FOR_START = "WAITING_FOR_START",
    INVESTOR_RECIVING_INTREST = "INVESTOR_RECIVING_INTREST",
    PROJECT_COMPLETED = "PROJECT_COMPLETED", 
    FAILED = "FAILED",
    FAILD_PROCESS = "FAILD_PROCESS"
}

type ProjectStatusWithFailReason = {
    status: ProjectStatus;
    reason: string;
}

export const getProjectStatusWithReasonToFail = (project: Project): ProjectStatusWithFailReason => {
    try {
        //Test core information
        const { currentFunding, durationMax, durationMin, deadline, interestRate, minimumInvestment, targetFunding } = project.finance
        if (currentFunding === undefined || durationMax === undefined || interestRate === undefined || minimumInvestment === undefined || targetFunding === undefined || targetFunding === 0) return ({
            status: ProjectStatus.HIDDEN,
            reason: "On of which is undefined [currentFunding, durationMin, durationMax, interestRate, minimumInvestment, targetFunding] or taget funding is zero" +
                currentFunding + durationMin + durationMax + interestRate + minimumInvestment + targetFunding
        })
        //Test set states
        const { forcedState, interestStartDate, interestEndDate } = project.state ? project.state : { forcedState: undefined, interestStartDate: undefined, interestEndDate: undefined }
        if (forcedState === ProjectForcedStates.HIDDEN) return { status: ProjectStatus.HIDDEN, reason: "Implicit set status" }
        if (forcedState === ProjectForcedStates.COMMING_SOON) return { status: ProjectStatus.COMMING_SOON, reason: "Implicit set status as this" }
        if (forcedState === ProjectForcedStates.FAILD_PROCESS) return { status: ProjectStatus.FAILD_PROCESS, reason: "Implicit set status as this" }
        if (forcedState === ProjectForcedStates.FAILED) return { status: ProjectStatus.FAILED, reason: "Implicit set status as this" }

        //Fields
        const { nonLocalizedContent, localizedContent } = project
        const fullyFunded = currentFunding + minimumInvestment > targetFunding

        //Waiting for start
        if (fullyFunded && !interestStartDate) return { status: ProjectStatus.WAITING_FOR_START, reason: "Fully funded but start date has not been set" }
        if (!fullyFunded && deadline && fbDateToUnix(deadline) < Date.now()) return { status: ProjectStatus.WAITING_FOR_START, reason: "Not fully funded but deadline is due" }
        if (fullyFunded && interestStartDate && fbDateToUnix(interestStartDate) > Date.now()) return { status: ProjectStatus.WAITING_FOR_START, reason: "Fully funded but start date is not due" }

        //Paid back
        if (interestStartDate && interestEndDate && fbDateToUnix(interestEndDate) < Date.now()) return { status: ProjectStatus.PROJECT_COMPLETED, reason: "Interest end date is set in the past" }

        //Counting interest 
        if (interestStartDate && fbDateToUnix(interestStartDate) < Date.now()) return { status: ProjectStatus.INVESTOR_RECIVING_INTREST, reason: "Fully funded and interest start date is set in the past" }

        //Open for investment
        if (!fullyFunded && nonLocalizedContent && nonLocalizedContent.contractTemplateId) return { status: ProjectStatus.OPEN_FOR_INVESTMENT, reason: "Open for investment" }

        const reason = "No reason matched. Fullyfunded" + fullyFunded + "nonLocalizedContent" + nonLocalizedContent + "localizedContent" + localizedContent + "nonLocalizedContent.contractTemplateId" + nonLocalizedContent?.contractTemplateId
        return { status: ProjectStatus.COMMING_SOON, reason }
    } catch (e) {
        console.log(e)
        return { status: ProjectStatus.HIDDEN, reason: JSON.stringify(e) }
    }
}

export const getProjectStatus = (project: Project): ProjectStatus => {
    const result = getProjectStatusWithReasonToFail(project)
    return result.status
}



const hidden = { name: "HIDDEN", color: ProjectStatusColor.RED }
const commingSoon = { name: ProjectStatusLabel.PROJECT_COMMING_SOON, color: ProjectStatusColor.YELLOW }
const openForInvestmen = { name: ProjectStatusLabel.PROJECT_OPEN_FOR_INVESTMENT, color: ProjectStatusColor.BLUE }
const projectWatingForStart = { name: ProjectStatusLabel.PROJECT_WAITING_FOR_START, color: ProjectStatusColor.GRAY }
const investorRecivingIntrest = { name: ProjectStatusLabel.PROJECT_IN_PROGRESS, color: ProjectStatusColor.GREEN }
const investmentCompleted = { name: ProjectStatusLabel.PROJECT_IN_COMPLETED, color: ProjectStatusColor.GRAY }
const failed = { name: ProjectStatusLabel.PROJECT_FAILED, color: ProjectStatusColor.RED }
const failedProcess = { name: ProjectStatusLabel.PROJECT_FAIL_IN_PROCESS, color: ProjectStatusColor.RED }

export const getProjectStatusUILabel = (project: Project): ProjectStatusUILabel => {
    const status = getProjectStatus(project)
    switch (status) {
        case ProjectStatus.HIDDEN: return hidden;
        case ProjectStatus.COMMING_SOON: return commingSoon;
        case ProjectStatus.OPEN_FOR_INVESTMENT: return openForInvestmen;
        case ProjectStatus.WAITING_FOR_START: return projectWatingForStart;
        case ProjectStatus.INVESTOR_RECIVING_INTREST: return investorRecivingIntrest;
        case ProjectStatus.PROJECT_COMPLETED: return investmentCompleted;
        case ProjectStatus.FAILD_PROCESS: return failedProcess;
        case ProjectStatus.FAILED: return failed;
    }
}